(function() {
	
	const modalOpenBtns = document.getElementsByClassName("js-show-modal");
	for (let i = 0; i < modalOpenBtns.length; i++) {
		modalOpenBtns[i].addEventListener("click", function() {
			document.getElementById( this.dataset.target ).classList.add("active");

			// document.body.style.paddingRight = "16px";
			// document.body.style.overflow = "hidden";
		});
	}

	const modals = document.getElementsByClassName("js-modal");
	for (let i = 0; i < modals.length; i++) {
		modals[i].addEventListener("click", function(event) {

			if (event.target == this) {
				this.classList.remove("active");

				setTimeout(() => {
					document.body.removeAttribute("style");
				}, 220);
			}
		});
	}

	const closeBtns = document.getElementsByClassName("js-close-modal");
	for (let i = 0; i < closeBtns.length; i++) {
		closeBtns[i].addEventListener("click", function() {
			this.getParentByClassName("js-modal").classList.remove("active");

			setTimeout(() => {
				document.body.removeAttribute("style");
			}, 220);
		});
	}
})();